@import 'src/styles/common/_colors.scss';

.modalRoot {
	position: fixed;
    z-index: 1300;
    inset: 0px;
	overflow-y: scroll;
	.modalBackdrop {
		position: fixed;		
		z-index: -1;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: $smoke-white;		
	}
	.icon-close:before {
		content: "\e614";
	}
	.modalContainer {
		height: 100%;
		outline: 0px;
		display: flex;
		-webkit-box-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		align-items: center;
		opacity:1;
		transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
		& .modalWrapper {
			transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
			-webkit-box-shadow: inset 0 -1px 1px $smoke-white;
			-moz-box-shadow: inset 0 -1px 1px $smoke-white;
			box-shadow: inset 0 -1px 1px $smoke-white;
			margin: 2rem 1rem;
			position: relative;
			overflow-y: auto;
			display: flex;
			flex-direction: column;
			max-height: calc(140% - 64px);
			max-width: 600px;
			min-width: 200px;
			opacity: 0;
			border-radius: 0.5rem;	
			&.fade.in {
				display: flex;
				background: $dialog-background-color;					
				opacity:1;
				transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
				overflow: visible;
			}			
			& .modalContent {
				padding: 0.625rem;
				border-top: 1px solid $gray-variant-1;	
				border-bottom: 1px solid $gray-variant-1;	
				display: flex;
    			flex-direction: column;
			}
			&.fullScreen {
				max-width: 100%;
				width: 100%;
				height: 100%;				
				overflow-y: hidden;
				& .modalContent {
					height: calc(100% - 90px);				
				}
			}
			&.halfScreen {
				max-width: 85%;
				width: 85%;
				height: 85%;				
				overflow-y: hidden;
				& .modalContent {
					height: calc(100% - 90px);				
				}
			}
		}
	}
	.modalHeader {
		height: 40px;
		padding: 0 0.625rem;
		display: flex;
		position: relative;
		align-items: center;
		h3 {        
			margin: 0;
        }
	}
	.modalClose {
		position: absolute;
		cursor: pointer;
		background:none;
		right: 4px;
		top: 10px;
		padding: 4px 6px;
		color:$white;
		font-size:0.625rem;
		border: none;
	}

	.appliedIocnStyles {
		margin-right: 10px;
		color: #a3ca12;
		vertical-align: middle;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.footermodalClose {
		margin-right: 5px;
		color: #a3ca12;
		vertical-align: middle;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	

	.modalFooter {
		border: none;
		-moz-box-shadow: none;
		box-shadow: none;
		padding: 12px 10px 12px 12px;
		position: absolute;
		bottom: 0px;
		left: 0;
		width: 100%;
		justify-content: flex-end;
		display: flex;
		height: 50px;
		& .button {
			min-width: 41px;
		}

		& .button+.button {
			margin-left: 6px;
		}
	}
}